import api from '@edu-fe/api'

export default {
  name: 'freeVideo',
  getData: api.create('/freevideo/list'),
  search: api.create('/freevideo/search/v2'),
  detail: api.create('/freevideo/one')
}
